import { useUserConfig } from '@littlebird/sdk';

import { useChannelConnectionQuery } from '@/features/msg-channels/common/msg-channels.query';
import {
  MESSAGING_CHANNEL_TYPES,
  MESSAGING_DELIVERY_OFF,
  MessagingChannelTypes,
  type MessagingDeliveryChannel,
} from '@/features/msg-channels/common/msg-channels.types';

/** The messaging channel that also receives the proactive agents' cards, and the importance a card needs to go there. */
export const useCardChannelDelivery = () => {
  // React Compiler would cache the settings store read and miss its changes.
  'use no memo';

  const userConfig = useUserConfig();
  const delivery = userConfig.proactiveAgents.get('card_delivery');
  const live = {
    [MessagingChannelTypes.IMESSAGE]: useChannelConnectionQuery(
      MessagingChannelTypes.IMESSAGE
    ).data?.has_active_conversation,
    [MessagingChannelTypes.WHATSAPP_BUSINESS]: useChannelConnectionQuery(
      MessagingChannelTypes.WHATSAPP_BUSINESS
    ).data?.has_active_conversation,
  };
  const liveChannels = MESSAGING_CHANNEL_TYPES.filter((type) => live[type]);
  // The channel the backend sends to: the chosen one while it has a live conversation, else the first that has one
  const channel: MessagingDeliveryChannel =
    delivery.channel === MESSAGING_DELIVERY_OFF
      ? MESSAGING_DELIVERY_OFF
      : (liveChannels.find((type) => type === delivery.channel) ??
        liveChannels[0] ??
        MESSAGING_DELIVERY_OFF);
  return {
    channel,
    minImportance: delivery.min_importance,
    setChannel: (channel: MessagingDeliveryChannel) =>
      userConfig.proactiveAgents.setFields('card_delivery', { channel }),
    setMinImportance: (minImportance: number) =>
      userConfig.proactiveAgents.setFields('card_delivery', {
        min_importance: minImportance,
      }),
  };
};
